(function ($) {
    $(function () {
        $('.youtube-slider').slick({
            slidesToShow: 2,
            swipeToSlide: false,
            dots: false,
            adaptiveHeight: true,
            autoplay: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                }]
        });
    });
})(window.jQuery);